<template>
        <div  class="grid gap-3 lg-grid-cols-4 sm-grid-cols-3 xs-grid-cols-1">
            <template v-for="item in getPlaces" >
                <article class="mvt-place" v-if="item.photo" :key="item.id">
                    <img loading="lazy" :src="item.photo" :alt="item.vicinity"/>
                    <sup>
                        <i :class="item.icon" v-if="item.icon"></i>
                        <span v-if="item.tag">{{item.tag}}</span>
                    </sup>
                    <b>{{ item.name }}</b>
                    <address>{{ item.vicinity }}</address>
                </article>
            </template>
        </div>
</template>
<script src="./mvt-nearbyplaces.js"></script>
<style lang="scss">
@use './mvt-nearbyplaces.scss' as *;
</style>
